module.exports = __webpack_public_path__ + "img/xiaoshou_img1@3x.6ac1dfe4.png";